import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { createVNode, reactive } from 'vue';
import { message, Modal } from 'ant-design-vue';
import { change_apiurl_auth, import_apiurl } from 'liyu-pc-base/api/permission/apiurl-manage';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { event_obj } from 'liyu-pc-base/init-plugin';
import type { BtnListConfig, HeadBtnListConfig } from 'liyu-pc-base/api/typing';
export const btn_list: BtnListConfig = [
  {
    name: '设为需要授权',
    type: 'dropdown',
    clazz: 'primary',
    is_show: ({ record }) => {
      return record.is_active && !record.is_auth;
    },
    cb: ({ record, current_org }) => {
      Modal.confirm({
        title: '是否设为需要授权?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve => {
            change_apiurl_auth({
              org_id: current_org.id,
              apiurl_id: record.id,
              is_auth: true,
            }).then((res: any) => {
              message.success('操作成功');
              Object.assign(record, res);
              resolve(null);
              event_obj().emit('refresh');
            });
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
      });
    },
  },
  {
    name: '设为无需授权',
    type: 'dropdown',
    clazz: 'primary',
    is_show: ({ record }) => {
      return record.is_active && record.is_auth;
    },
    cb: ({ record, current_org }) => {
      Modal.confirm({
        title: '是否设为无需授权?',
        icon: createVNode(ExclamationCircleOutlined),
        onOk() {
          return new Promise(resolve => {
            change_apiurl_auth({
              org_id: current_org.id,
              apiurl_id: record.id,
              is_auth: false,
            }).then((res: any) => {
              message.success('操作成功');
              Object.assign(record, res);
              resolve(null);
              event_obj().emit('refresh');
            });
          }).catch(() => console.log('Oops errors!'));
        },
        onCancel() {},
      });
    },
  },
];
export const config = {
  creatCol: [],
  updateCol: [],
};

export const head_btn_list: HeadBtnListConfig = [
  {
    name: '导入接口',
    type: 'dropdown',
    clazz: 'primary',
    cb: () => {
      const editModal = reactive({
        visible: true,
        title: '导入api接口json文件',
        loading: false,
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'vertical',
            col: [],
          },
          fields: [
            {
              type: 'textarea',
              name: 'api_json',
              label: '接口JSON',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              maxlength: 100,
              defaultValue: '',
              placeholder: '接口JSON',
            },
          ],
          rules: {
            api_json: [{ username: true, message: '请填写账号名称' }],
          },
          model: reactive({
            org_id: current_org.id,
            api_json: '',
          }),
        },
        options: {},
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            import_apiurl({
              ...payload,
            })
              .then(() => {
                message.success('导入成功');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
